export const handleColorStatusConsultRequestUtil = (
  status_type: string,
  handle_by: string
) => {
  if (status_type === "pending") {
    return "รอตรวจสอบ";
  } else if (status_type === "response") {
    if (handle_by === "advisor") {
      return "ตอบกลับแล้ว";
    } else {
      return "มีการตอบกลับ";
    }
  } else if (status_type === "new_request") {
    if (handle_by === "advisor") {
      return "ปรึกษาเพิ่มเติม";
    } else {
      return "รอตรวจสอบ";
    }
  } else if (status_type === "success") {
    return "สิ้นสุดการให้คำปรึกษา";
  } else {
    return "";
  }
};

export const handleTextStatusConsultRequestUtil = (status_type: string) => {
  if (status_type === "pending") {
    return "warning";
  } else if (status_type === "response") {
    return "info";
  } else if (status_type === "new_request") {
    return "warning";
  } else if (status_type === "success") {
    return "success";
  } else {
    return "default";
  }
};

export const allStatusConsultRequestUtil = [
  "pending",
  "response",
  "new_request",
  "success",
];

export const allStatusAdvisorRequestUtil = [
  "รอพิจารณา",
  "ตอบรับเป็นที่ปรึกษา",
  "ปฏิเสธคำขอ",
  "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง",
  "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง",
  "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา",
];
